import { MultiValuedList } from '../../MultiValuedList'
import { FileMultiValuedListItem } from '../FileMultiValuedListItem'
import { FileMultiValuedListMoreItem } from '../FileMultiValuedListMoreItem'

import { FILE_MULTI_VALUED_LIST_MORE_DROPDOWN_HEIGHT } from './FileMultiValuedList.constants'
import { filterByName } from './FileMultiValuedList.utils'

function FileMultiValuedList({
  Item = FileMultiValuedListItem,
  MoreItem = FileMultiValuedListMoreItem,
  filter = filterByName,
  moreItemsProps,
  ...restProps
}) {
  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      filter={filter}
      moreItemsProps={{
        ...moreItemsProps,
        maxHeight: FILE_MULTI_VALUED_LIST_MORE_DROPDOWN_HEIGHT,
      }}
    />
  )
}

export default FileMultiValuedList
